import React, {useState} from 'react';
import {
  ActivityIndicator,
  Button,
  Chip,
  Dialog,
  Divider,
  IconButton,
  List,
  Text,
  TextInput,
} from 'react-native-paper';
import {useMutation, useQuery} from 'react-query';
import {View, Clipboard, Platform} from 'react-native';
import {
  createDBConn,
  dbMnemoCons,
  evolu,
  initDatabaseRecord,
} from '../../api/db';
import {getDatabases} from '../../api/db/supervisor';
import {DatabaseItem} from '../../types';
import {useAppDispatch, useAppSelector} from '../../store/hooks';
import {setEditingMode} from '../../store/slices/ui';
import {genMnemonic} from '../../api';

export function DatabaseItemComponent({
  db,
  totalLength,
  showMnemonic,
}: {
  db: DatabaseItem;
  totalLength: number;
  showMnemonic: (i: DatabaseItem) => void;
}) {
  const currentMnemonic = evolu!.getOwner()?.mnemonic;
  const isCurrent = db.mnemonic === currentMnemonic;
  const mnemonic = db.mnemonic as string;
  const loginMutation = useMutation(async () => {
    try {
      if (!dbMnemoCons[mnemonic]) {
        await createDBConn(db.title, db.mnemonic, true);
      }
      await initDatabaseRecord(
        'previous',
        currentMnemonic,
        dbMnemoCons[mnemonic],
      );
    } catch (err) {
      console.error(err);
    }
    evolu.restoreOwner(db.mnemonic);
  });
  const logoutDatabase = (i: DatabaseItem) => {};
  const loginDatabase = (i: DatabaseItem) => {
    loginMutation.mutateAsync();
  };
  return (
    <List.Item
      key={db.id}
      left={props => <List.Icon {...props} icon={'database'} />}
      right={props => (
        <>
          {/* {totalLength > 1 && (
              <Button
                {...props}
                icon={'logout'}
                mode="outlined"
                onPress={() => logoutDatabase(db)}>
                Logout
              </Button>
            )} */}
          {!isCurrent && (
            <Button
              {...props}
              icon={'archive-arrow-down'}
              mode="outlined"
              onPress={() => loginDatabase(db)}>
              Switch
            </Button>
          )}
          <Button
            {...props}
            icon={'eye'}
            mode="outlined"
            onPress={() => showMnemonic(db)}>
            Show
          </Button>
        </>
      )}
      description={
        <View style={{gap: 10, flexDirection: 'row'}}>
          {/* <Chip>{`${new Date(db.date).toDateString()}`}</Chip> */}
          {isCurrent && (
            <Chip style={{backgroundColor: 'green'}}>Current</Chip>
          )}
        </View>
      }
      title={`${db.title}`}
    />
  );
}

export default function DatabasesScreen() {
  const dbReq = useQuery('Databases', () => getDatabases(), {
    refetchOnWindowFocus: false,
  });
  const isLoading = dbReq.isLoading;
  const dbs = dbReq.data;
  const [mnemonic, setShowMnemonic] = useState<string | undefined>(
    undefined,
  );
  const [dbName, setDbName] = useState<string>('');
  const [dbMnemonic, setDbMnemonic] = useState<string>('');
  const showMnemonic = (i: DatabaseItem) =>
    setShowMnemonic(i.mnemonic);

  const createDBMutation = useMutation(
    async () => {
      console.info('createdb');
      return await initDatabaseRecord(dbName, dbMnemonic);
    },
    {
      onSuccess: () => {
        dispatch(setEditingMode(undefined));
        dbReq.refetch();
      },
    },
  );
  const showCreate = useAppSelector(
    state => state.ui.editingMode === 'database',
  );
  const dispatch = useAppDispatch();
  if (isLoading) return <ActivityIndicator size={72} />;
  return (
    <>
      <List.Section>
        {dbs?.map(db => (
          <DatabaseItemComponent
            db={db}
            totalLength={dbs.length}
            showMnemonic={showMnemonic}
          />
        ))}
      </List.Section>
      <Dialog
        style={{maxWidth: 500}}
        visible={mnemonic !== undefined}
        onDismiss={() => setShowMnemonic(undefined)}>
        <Dialog.Title>Mnemonic</Dialog.Title>
        <Dialog.Content>
          <Text>{mnemonic}</Text>
        </Dialog.Content>
        <Dialog.Actions>
          <Button
            icon={'clipboard'}
            onPress={() => (
              Clipboard.setString(mnemonic as string),
              setShowMnemonic(undefined)
            )}>
            Copy
          </Button>
        </Dialog.Actions>
      </Dialog>
      <Dialog
        visible={showCreate}
        style={{maxWidth: 500}}
        onDismiss={() => dispatch(setEditingMode(undefined))}>
        <Dialog.Title>Create a new Database</Dialog.Title>
        <Dialog.Content>
          <TextInput
            label={'Database Name'}
            value={dbName}
            onChangeText={setDbName}
          />
          <TextInput
            label={'Database Mnemonic'}
            value={dbMnemonic}
            onChangeText={setDbMnemonic}
          />
        </Dialog.Content>
        <Dialog.Actions>
          <Button
            key={'close'}
            icon={'close'}
            onPress={() => {
              dispatch(setEditingMode(undefined));
            }}>
            Cancel
          </Button>
          <Button
            key={'matrix'}
            icon={'matrix'}
            onPress={() => {
              setDbMnemonic(genMnemonic());
            }}>
            Generate New Mnemonic
          </Button>
          <Button
            key={'check'}
            icon={'check'}
            disabled={
              dbName.length < 3 || dbMnemonic.split(' ').length !== 12
            }
            onPress={() => createDBMutation.mutateAsync()}
            loading={createDBMutation.isLoading}>
            Save
          </Button>
        </Dialog.Actions>
      </Dialog>
    </>
  );
}
